"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoordsByPosition = getCoordsByPosition;
exports.getAlignmentByPosition = getAlignmentByPosition;

function getCoordsByPosition(position, itemRect, stageRect, padding) {
  let y = null;
  let x = null;

  switch (position[0]) {
    case 'T':
      y = padding;
      break;

    case 'M':
      y = stageRect.height / 2 - itemRect.height / 2;
      break;

    case 'B':
      y = stageRect.height - itemRect.height - padding;
      break;

    default:
      y = null;
  }

  switch (position[1]) {
    case 'L':
      x = padding;
      break;

    case 'C':
      x = stageRect.width / 2 - itemRect.width / 2;
      break;

    case 'R':
      x = stageRect.width - itemRect.width - padding;
      break;

    default:
      x = null;
  }

  return {
    x,
    y
  };
}

function getAlignmentByPosition(position) {
  let alignment;

  switch (position[1]) {
    case 'L':
      alignment = 'left';
      break;

    case 'C':
      alignment = 'center';
      break;

    case 'R':
      alignment = 'right';
      break;

    default:
      alignment = null;
  }

  return alignment;
}